import {
  DeleteOutlineIcon,
  EditOutlinedIcon,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
  type MoreMenuIconButtonProps,
} from '@shared/components';
import { useMemo } from 'react';

import { useQConfigStructureModal } from '../../providers';

export interface TopicTableRowMenuProps extends Omit<MoreMenuIconButtonProps, 'options'> {
  qConfigStructureId: string;
  onUpdate: () => void;
}

export function TopicTableRowMenu(props: Readonly<TopicTableRowMenuProps>) {
  const { qConfigStructureId, onUpdate } = props;

  const { setAction } = useQConfigStructureModal();

  const handleRemove = () => {
    setAction({
      action: 'QCONFIG_DELETE',
      payload: { qConfigStructureId },
    });
  };

  const editOption: MoreMenuIconButtonOption = {
    icon: (
      <EditOutlinedIcon
        sx={{
          color: (theme) => theme.palette.grey[600],
        }}
      />
    ),
    label: 'Edit',
    onClick: onUpdate,
    sx: {
      ':hover': {
        backgroundColor: (theme) => theme.palette.primary.lighter,
      },
    },
  };

  const deleteOption: MoreMenuIconButtonOption = {
    icon: (
      <DeleteOutlineIcon
        sx={(theme) => ({
          color: theme.palette.error.main,
        })}
      />
    ),
    label: 'Delete',
    onClick: handleRemove,
    sx: (theme) => ({
      ':hover': {
        backgroundColor: theme.palette.primary.lighter,
      },
      color: theme.palette.error.main,
    }),
  };

  const topicMenuOptions: MoreMenuIconButtonOption[] = useMemo(() => {
    const options = [];

    options.push(editOption);
    options.push(deleteOption);

    return options;
  }, [deleteOption, editOption]);

  return (
    <MoreMenuIconButton
      options={topicMenuOptions}
      slotProps={{
        iconButton: { sx: { color: (theme) => theme.palette.grey[500] } },
      }}
    />
  );
}
